if(!customElements.get('swiper-carousel')) {
  class SwiperCarousel extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.id = this.dataset.id;
      this.initCarousel(this.data);
      this.setupListeners();
    }

    setupListeners() {
      const pagers = this.querySelectorAll(".carousel-pager");
      const prev = this.querySelector(".carousel-prev");
      const next = this.querySelector(".carousel-next");

      if (this.swiper.activeIndex === 0) {
        prev.classList.add("carousel__arrow--deactive");
      }

      this.swiper.on("slideChange", () => {
        pagers.forEach((el) => el.classList.remove("active"));
        const next = pagers[this.swiper.realIndex];
        if (next) {
          next.classList.add("active");
        }
      });

      Array.from(pagers).forEach((pager, i) => {
        pager.addEventListener("click", (e) => {
          this.swiper.slideTo(i + 1);
        });
      });

      if (prev) {
        prev.addEventListener("click", () => {
          let realIndex = this.swiper.activeIndex;

          // deactivePrevArrow(realIndex);

          if (this.swiper) {
            this.swiper.slidePrev();
          }
        });
      }

      if (next) {
        next.addEventListener("click", () => {
          let realIndex = this.swiper.activeIndex;

          // deactiveNextArrow(realIndex);

          if (this.swiper) {
            this.swiper.slideNext();
          }
        });
      }

      this.swiper.on("slideChange", function (e) {
        const idx = e.realIndex;
        const thumbs = document.querySelectorAll(".swiper__thumb");
        thumbs.forEach((thumb) => thumb.classList.remove("active"));

        if (thumbs[idx]) {
          thumbs[idx].classList.add("active");
        }
      });

      this.addEventListener("click", (e) => {
        const button = e.target.closest("button");
        if (button && button.matches(".swiper__thumb")) {
          const thumbs = document.querySelectorAll(".swiper__thumb");
          const idx = Array.from(thumbs).indexOf(button);
          thumbs.forEach((thumb) => thumb.classList.remove("active"));
          button.classList.add("active");
          this.swiper.slideTo(idx + 1);
        }
      });
    }

    initCarousel(
      config = {
        slidesPerView: 1,
        loop: true,
        breakpoints: {
          1024: {
            slidesPerView: 3,
          },
        },
        spaceBetween: 19,
      }
    ) {
      this.swiper = new Swiper(`#${this.id} .swiper`, config);
    }
  }

  customElements.define("swiper-carousel", SwiperCarousel);
}
